import { Outlet } from 'react-router-dom';
import { AppShell, Box, Flex } from '@mantine/core';
import AppFooter from '@/components/AppFooter';
import PublicHeader from '@/components/PublicHeader';
import SkipLink from '@/components/SkipLink';
import classes from './GlassHeader.module.css';

const HEADER_HEIGHT = 64;

// Публичная оболочка: фиксированный «стеклянный» хедер (blur) + scrollable Main.
// Sticky-footer: контент растягивается (flex-grow), футер прижат к низу — без жёстких высот,
// поэтому корректно скроллится при любой высоте окна и на мобильном.
export default function PublicLayout() {
  return (
    <AppShell header={{ height: HEADER_HEIGHT }} padding={0}>
      <SkipLink />
      <AppShell.Header className={classes.glass}>
        <PublicHeader />
      </AppShell.Header>

      <AppShell.Main id="main" tabIndex={-1}>
        <Flex direction="column" mih={`calc(100dvh - ${HEADER_HEIGHT}px)`}>
          <Box style={{ flexGrow: 1 }}>
            <Outlet />
          </Box>
          <AppFooter />
        </Flex>
      </AppShell.Main>
    </AppShell>
  );
}
